import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';

import {
    Container,
    Grid,
} from '@material-ui/core';
import LogOutLeftSection from "../../elements/logOutLeftSection";
import {Unsubscribe} from '../../component';
import {unsubscribe} from "../../vendors/actions/user";
import {resetUnsubscribe} from "../../vendors/actions/layout";

interface OwnProps {
    match:any,
    unsubscribeUser?:any
    resetUnsubscribe?:any
}

interface ConnectDispatchProps {
    unsubscribeUser?: (data: any) => void,
    resetUnsubscribe?: () => void,
}

interface ConnectStateProps {

}

interface MainState {}

type HeaderProps = OwnProps & ConnectDispatchProps;

class UnsubscribeUser extends React.Component<HeaderProps, MainState> {

    componentDidMount() {
        const {params} = this.props.match;
        this.props.unsubscribeUser({
            token:params.t,
            type:params.mt,
            action:params.action
        });
    }

    componentWillUnmount() {
        this.props.resetUnsubscribe();
    }

    static getDerivedStateFromProps(props: any) {
        return null
    }

    render() {
        const {params} = this.props.match;
        return (
            <Fragment>
                <div className="app-wrapper min-vh-100 bg-white">
                    <div className="app-main min-vh-100">
                        <div className="app-content p-0">
                            <div className="app-inner-content-layout--main">
                                <div className="flex-grow-1 w-100 d-flex align-items-center">
                                    <div className="bg-composed-wrapper--content">
                                        <Grid container spacing={0} className="min-vh-100">
                                            <LogOutLeftSection />
                                            <Grid
                                                item
                                                xs={12}
                                                md={8}
                                                lg={7}
                                                className="d-flex align-items-center">
                                                <Container maxWidth="lg">
                                                    <Container maxWidth="lg">
                                                        <Unsubscribe
                                                            token={params.t}
                                                            type={params.mt}
                                                            action={params.action}/>
                                                    </Container>
                                                </Container>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Layout} = state;
    return {
        Layout
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        unsubscribeUser: (data: any) => dispatch(unsubscribe(data)),
        resetUnsubscribe: () => dispatch(resetUnsubscribe()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UnsubscribeUser);
